import React from "react";
import ActivityLogsList from "../../components/ActivityLogs/ActivityLogsList";
import "./activityLogs.css";
import { useParams } from "react-router-dom";

export default function ActivityLogs() {
  const { entityType, entityId } = useParams();
  
  return (
    <div className="activity-logs-container">
      <ActivityLogsList 
        entityType={entityType}
        entityId={entityId}
        showEntityFilter={true}
        title="Activity Logs"
      />
    </div>
  );
}